import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { first, shareReplay } from 'rxjs';
import { Table } from 'primeng/table';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { DatePipe } from '@angular/common';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ReportsService } from 'src/app/services/reports.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-mi-pond-target',
  templateUrl: './mi-pond-target.component.html',
  styleUrls: ['./mi-pond-target.component.scss'],
  providers: [DatePipe],
})
export class MiPondTargetComponent implements OnInit {

  @ViewChild('miPondTable', { static: true })
  public miPondTable: Table;

  public userId: any;
  public miData: any = [];
  public pondData: any = [];
  public subscriptions: any = []
  public subjectSub: any;
  public selectedYear: any;
  public loadingMI: boolean = false;
  public loadingPond: boolean = false;
  public ipAddress: any;
  public showDialogToInsertTarget: any;
  public isSubmitted: boolean = false;
  public insertStatusForm: FormGroup;
  public menuItemsMI: MenuItem[];
  public menuItemsPond: MenuItem[];

  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  public districtList: any;
  public programmeList: any;
  public programmeTypeList: any;
  public isProgMI: boolean = false;
  public casteList: any = [];
  public atalBhujalSchemeList: any = [];
  public blockList: any = [];
  public villageList: any = [];

  public selectProgType: any = 'MI';
  public todayDate: Date;

  constructor(
    private service: BaseService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private ipService: IpAddressService,
    private confirmationService: ConfirmationService,
    private loader: AppLoaderService,
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private cryptoJsService: CryptoJsService,
    private reportService: ReportsService,
    private vendorService: VendorDashboardService,
  ) { }

  ngOnInit(): void {
    this.todayDate = new Date();
    this.loadMIData();
    this.loadPondData();
    this.getProgramTypeMaster();
    this.getComponentMaster();
    this.getCasteList();
    this.getAtalBhujalList();

    this.menuItemsMI = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.miData, "FY: MI Target");
        }
      },
    ];

    this.menuItemsPond = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.pondData, "FY: Pond Target");
        }
      },
    ];

    this.insertStatusForm = this._fb.group({
      district: ['', Validators.required],
      block: [''],
      village: [''],
      programme: ['', Validators.required],
      programmeType: ['', Validators.required],
      area: ['', Validators.required],
      // amount: ['', Validators.required],
      // farmersToBeBenefitted: ['', Validators.required],
      caste: ['', Validators.required],
      abyUser: ['', Validators.required],
      fromDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });

    // this.getVillageData();
  }

  getAtalBhujalList(){
    setTimeout(() => {
      this.atalBhujalSchemeList = [
        { label: 'All', value: 0 },
        { label: 'Atal Bhujal Village', value: 1 }
      ]
    }, 200)
  }

  getCasteList(){
    setTimeout(() => {
      this.casteList = [
        { label: 'All', value: 0 },
        { label: 'Gen', value: 1 },
        // { label: 'BC', value: 2 },
        { label: 'SC/ST', value: 3 },
      ]
    }, 200)
  }

  getComponentMaster() {
    // this.loader.start();
    let sub = this.vendorService
      .getComponentMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.programmeList = res;
          // this.loader.close();
        },
        error: (err) => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectAtalScheme(){
    this.insertStatusForm.controls.block.setValue(null);
    this.insertStatusForm.controls.block.setValue(null);
    this.insertStatusForm.controls.village.setValue(null);
    this.districtList = [];
    this.blockList = [];
    this.villageList = [];

    let val = this.insertStatusForm.value;
    
    let schemeCode = val?.abyUser?.value
    this.getDistrictList(schemeCode);
  }

  getDistrictList(schemeCode) {
    let sub = this.reportService
      .getDistrictMasterOther(schemeCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.districtList = data;
          } else {
            this.districtList = [];
          }
        },
        error: (err) => {
          this.districtList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'District List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectDistrict(){
    // this.selectedBlock = null;
    this.insertStatusForm.controls.block.setValue(null);
    this.insertStatusForm.controls.village.setValue(null);
    this.blockList = [];
    this.villageList = [];

    let val = this.insertStatusForm.value;
    
    let districtCode = val?.district.Dist_Code;
    let schemeCode = val?.abyUser?.value
    this.getBlockList(districtCode, schemeCode);
  }

  getBlockList(districtCode, schemeCode) {
    let sub = this.reportService
      .getBlockMasterOther(districtCode, schemeCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.blockList = data;
          } else {
            this.blockList = [];
          }
        },
        error: (err) => {
          this.blockList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Block List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectBlock(){
    // this.selectedVillage = null;
    this.insertStatusForm.controls.village.setValue(null);
    this.villageList = [];

    let val = this.insertStatusForm.value;
    let districtCode = val?.district.Dist_Code;
    let blockCode = val?.block.Block_Code ? val?.block?.Block_Code : '';
    let schemeCode = val?.abyUser?.value
    this.getVillageList(districtCode, blockCode, schemeCode);
  }

  getVillageList(districtCode, blockCode, schemeCode) {
    let sub = this.reportService
      .getVillageMasterOther(districtCode, blockCode, schemeCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.villageList = data;
          } else {
            this.villageList = [];
          }
        },
        error: (err) => {
          this.villageList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Village List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getProgramTypeMaster() {
    setTimeout(() => {
      this.programmeTypeList = [
        {
          name: 'MI',
          value: 'MI'
        },
        {
          name: 'Tank',
          value: 'Pond'
        }
      ]
    })
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  get insertStatusFormControls() {
    return this.insertStatusForm.controls;
  }

  // loadDataAndApplyFilter() {
  //   if (sessionStorage.getItem('financialYear')) {
  //     this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
  //   }

  //   this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
  //     (res) => {
  //       this.selectedYear = res;
  //       this.loadData();
  //     }
  //   );
  // }

  loadMIData() {
    this.getIP();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    // this.loader.start();
    this.loadingMI = true;
    let sub = this.deptDashBoardService
      .getTargetsMIPond('MI')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loadingMI = false;
          this.activityRecordService.activityRecord(this.userId, 'MI Target', '', new Date(), 'Success');

          this.userId = JSON.parse(payload)?.sub;
          // data = JSON.parse(data)
          if (data.length > 0) {
            this.miData = data.map((val) => ({
              ...val,
              Status: val?.Active == 1 ? 'Running' : val?.Active == 0 ? 'Closed' : val?.Active
            }))

            // this.miPondData.push(...respData);
          }
          else {
            this.miData = [];
            // this.miPondData = this.miPondData.push(...[]);
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.miData = [];
          // this.miPondData = this.miPondData.push(...[]);
          this.loadingMI = false;
          this.activityRecordService.activityRecord(this.userId, 'MI Target', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  loadPondData() {
    this.getIP();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    // this.loader.start();
    this.loadingPond = true;
    let sub = this.deptDashBoardService
      .getTargetsMIPond('Pond')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loadingPond = false;
          this.activityRecordService.activityRecord(this.userId, 'Pond Target', '', new Date(), 'Success');

          this.userId = JSON.parse(payload)?.sub;
          // data = JSON.parse(data)
          if (data.length > 0) {
            this.pondData = data.map((val) => ({
              ...val,
              Status: val?.Active == 1 ? 'Running' : val?.Active == 0 ? 'Closed' : val?.Active
            }))
            // this.miPondData.push(...respData);
          }
          else {
            this.pondData = [];
            // this.miPondData = this.miPondData.push(...[]);
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.pondData = [];
          this.loadingPond = false;
          this.activityRecordService.activityRecord(this.userId, 'Pond Target', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }


  addTarget() {
    // this.selectedOutlet = val;
    this.showDialogToInsertTarget = true;
  }

  hideDialog() {
    this.showDialogToInsertTarget = false;
    this.isSubmitted = false;
    this.insertStatusForm.reset();
    this.blockList = [];
  }

  saveProduct() {
    this.isSubmitted = true;
    if (this.insertStatusForm.valid) {
      let val = this.insertStatusForm.value;
      if (val?.fromDate > val?.endDate) {
        this.messageService.add({ severity: 'error', summary: 'Date Error', detail: 'Start date should before End date', life: 3000 });
        return;
      }
      let dataObj = [{
        GeoId: val?.village?.Vill_Code ? val?.village?.Vill_Code : val?.block?.Block_Code ? val?.block?.Block_Code : val?.district?.Dist_Code,
        GeoType: val?.village?.Vill_Code ? 'Village' : val?.block?.Block_Code ? 'Block' : val?.district?.Dist_Code ? 'District' : '',
        ProgId: val?.programme.Program_Id,
        ProgramType: val?.programmeType,
        Area: this.selectProgType == 'MI' ? val?.area : 0,
        Amount: 0,
        FarmersToBeBenefitted: this.selectProgType == 'Pond' ? val?.area : 0,
        ABYUser: val?.abyUser?.value,
        CasteCode: val?.caste?.value,
        StartDate: val.fromDate ? this.datePipe.transform(new Date(val.fromDate), 'yyyy-MM-dd') : val.fromDate,
        EndDate: val.endDate ? this.datePipe.transform(new Date(val.endDate), 'yyyy-MM-dd') : val.endDate,
      }]
      let reqBody = {
        listData: dataObj,
        userID: this.userId,
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
      }
      this.insertMiPondTarget(reqBody);
    }

  }

  insertMiPondTarget(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.deptDashBoardService
      .insertTarget(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data == "Insertion successful") {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

            if(reqBody?.listData?.[0]?.ProgramType == 'MI'){
              this.refreshMITable();
            }else if(reqBody?.listData?.[0]?.ProgramType == 'Pond'){
              this.refreshPondTable();
            }else{
              this.refreshMITable();
              this.refreshPondTable();
            }
            
            this.hideDialog();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
          this.activityRecordService.activityRecord(this.userId, 'Insert MI Pond Target', reqBody?.listData?.[0]?.GeoId, new Date(), 'Success', reqBody);
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userId, 'Insert MI Pond Target', reqBody?.listData?.[0]?.GeoId, new Date(), err, reqBody);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Financial Year": d.FinYear,
          "Programme Type": d.ProgramType,
          "Programme Name": d.ProgramName,
          "User Type": d.UserType,
          "District": d.District,
          "Caste": d.Caste,
          "Area": d.Area,
          "Total App": d.TotalApp,
          "Start Date": d.StartDate ? this.datePipe.transform(new Date(d.StartDate), 'yyyy-MM-dd') : d.StartDate,
          "End Date": d.Enddate ? this.datePipe.transform(new Date(d.Enddate), 'yyyy-MM-dd') : d.Enddate,
          "Current Status": d.Status,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  refreshMITable() {
    this.loadMIData();
  }

  refreshPondTable() {
    this.loadPondData();
  }

  rowBackgroundColor(row) {
    if (row.Active == 1) {
      //light green
      return '#99e699'
    }
    else if (row.Active == 0) {
      //red
      return '#ff8080';
    }
    else return '#ffffff';
  }

  updateStatus(val) {
    let updateStatus = '';
    if (val.Active == 1) {
      updateStatus = 'Inactive';
    } else if (val.Active == 0) {
      updateStatus = 'Active';
    }

    this.confirmationService.confirm({
      header: 'Confirmation',
      message: `Are you sure you want to update(${updateStatus}) the status of ${val?.ProgramName} and ${val?.ProgramType}`,
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm',
      accept: () => {
        let reqBody = {
          AutoId: val?.Autoid,
          Active: val?.Active
        }
        this.updateProgStatus(reqBody);
      },
      reject: () => {
        // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
    });
  }

  updateProgStatus(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    let sub = this.deptDashBoardService
      .updateMIPondTarget(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.refreshMITable();
            this.refreshPondTable();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectProg(val) {
    this.selectProgType = val;
    if (val == 'MI') {
      this.isProgMI = true;
      this.setProgramTypeList('MI');
    } else if (val == 'Pond') {
      this.isProgMI = false;
      this.setProgramTypeList('Pond');
    }
  }

  setProgramTypeList(val) {
    if (val == 'MI') {
      this.programmeList = [
        {
          "Program_Id": 0,
          "Program_Name": "All",
          "Active": true
        },
        {
          "Program_Id": 1,
          "Program_Name": "Portable Sprinkler",
          "Active": true
        },
        {
          "Program_Id": 2,
          "Program_Name": "Mini Sprinkler",
          "Active": true
        },
        {
          "Program_Id": 3,
          "Program_Name": "Drip",
          "Active": true
        }
      ]
    } else if (val == 'Pond') {
      this.programmeList = [
        {
          "Program_Id": 0,
          "Program_Name": "Tank",
          "Active": true
        }
      ]
      this.insertStatusFormControls.programme.setValue( this.programmeList[0] );
    }
  }
}

